import { useEffect, useRef, useState } from "react";
import useMapInteractivity from "./map.sideEffects/useMapInteractivity.sideEffects.js";
import useMap, { map } from "./map.sideEffects/useMap.sideEffects.js";
import useThreeJs from "./map.sideEffects/useThreeJS.sideEffects.js";
import useMapFilter from "./map.sideEffects/useMapFilter.sideEffects.js";
import usePosition from "./map.sideEffects/usePosition.sideEffect.js";
import useMapboxData from "./map.sideEffects/useMapboxData.sideEffects.js";
import useFeatures from "./map.sideEffects/useFeatures.sideEffects.js";
import "mapbox-gl/dist/mapbox-gl.css";
import styles from "./map.module.scss";
import { useSpring, a } from "react-spring";
import { connect } from "react-redux";
import * as actionFloor from "../../../reduxStore/actions/floors.js";
import * as actionMain from "../../../reduxStore/actions/main.js";
import * as actionMainNav from "../../../reduxStore/actions/mainNav.js";
import * as actionMap from "../../../reduxStore/actions/map.js";
import * as actionDebug from "../../../reduxStore/actions/debug.js";
import * as actionToast from "../../../reduxStore/actions/toasts";
import LoadingIcon from "../../elements/loading/spinner.component.jsx";
import {
  setGPSData,
  setLocationObjectZIndex,
} from "../../../reduxStore/actions/navigation.js";
import { setProperties } from "../../../reduxStore/actions/settings.js";
import * as actionInfo from "../../../reduxStore/actions/infoCard.js";
import { setMapPadding } from "../../../reduxStore/actions/map.js";
// import MapSDK from "@catchupapplications/map-sdk";
import MapSDK from "@catchupapplications/map-libre-sdk";
import {
  initCampus,
  piKey,
  useNewBuildingLabels,
} from "../../../app/app.sideEffects/useURLParams.sideEffects.js";
import { useCampusChange } from "./map.sideEffects/useCampusChange.js";
import { pageNames } from "../../../reduxStore/reducers/main";
import { getQueryParams } from "../../../app/RouteWithSubRoutes";
import { withRouter } from "react-router-dom";
import { CAMPUS_COLLECTION } from "../../../reduxStore/actions/main.js";

function Map(props) {
  // HTML Element für Mapbox
  const isInitialMount = useRef(true);
  // merkt sich immer die letzte Etage für Etagenwechsel Animation
  // Für die Animation (Fade in)
  const [{ opacity }, springAPI] = useSpring(() => ({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1500 },
  }));
  const [returnedMap, setReturnedMap] = useState();

  // SideEffects, die nach jedem Rendern (und nach dem ersten Mount)
  // ausgeführt werden
  useMap(returnedMap, props, springAPI, props.setMapPadding);
  useFeatures(props);
  useCampusChange(
    props.setCurrentFloorNumber,
    props.currentCampusId,
    props.mapLoaded,
    props.currentFeature,
    props.setCurrentCampusId,
    props.setCurrentCampusKey,
    props.serverDataLoaded,
    props.startLevel
  );
  useMapFilter(props);
  useThreeJs(props);
  useMapInteractivity(props);
  usePosition(props);
  useMapboxData(props);

  // const rasterImages = useGetRasterIamges(props.rasterImages);

  useEffect(() => {
    isInitialMount.current = false;
  }, []);

  useEffect(() => {
    const start = props.start;

    if (props.start && props.destination) {
      if (
        start?.constructor?.name === "StartDestination" ||
        (start?.positionType === "location" && start.lat === 0)
      ) {
        if (start.isNotSet()) return;
      }
      setTimeout(() => {
        props.history.push(
          `/${pageNames.map}/${pageNames.route}/${getQueryParams()}`
        );
      });

      //   props.history.push(`/${pageNames.map}/${pageNames.route}`);
    }
  }, []);

  if (actionMain.CAMPUS_COLLECTION) {
    const currentFloorLevel = actionMain.CAMPUS_COLLECTION.getLevelByIndex(
      props.currentFloorIndex
    );

    return (
      <div className={props.currentMainPage === "map" ? "" : "d-none"}>
        <LoadingIcon loading={!props.mapLoaded} icon={"map"} pulse={true} />
        <a.div
          className={`${
            styles.mapContainer
          } position-absolute bg-white pointer-event-on ${
            props.currentMainPage === "map" ? "" : "d-none"
          }`}
          style={{ opacity }}
        >
          <MapSDK
            map={{
              init: {
                zoom: 14,
                minZoom: 4,
                bearing:
                  props.terminalBearing != null ? props.terminalBearing : 0,
                pitch: 30,
                center:
                  actionMain.CAMPUS_COLLECTION.getCurrentCampus().center
                    .geometry.coordinates,
                dragRotate:
                  props.mapAngleFrozen != null ? !props.mapAngleFrozen : true,
              },

              visible: {
                buildingLabels: useNewBuildingLabels,
                buildingMarker: true,
              },
              onLoad: (map) => {
                // ich hab keine Ahnung. muss irgendwann richtig gefixt werden. Wahrscheinlich in der neuen Version
                // terminal geht manchmal sonst nicht

                setTimeout(() => {
                  //@ts-ignore
                  map._cuLayerSourceManager._setLayers(true);
                }, 3000);

                const interval = setInterval(function () {
                  if (map.campusCollection.getAllCampuses().length) {
                    setReturnedMap(map);
                    clearInterval(interval);
                  }
                }, 500);
              },

              extrusion: props.show3DBuildings,
              level: currentFloorLevel,
              setLevel: props.setCurrentFloorNumber,
            }}
            product={{
              rasterImages: props.rasterImages.map((r) => ({
                ...r,
                imageUrl: r.url,
                coords: r.corners,
                id: `${r.id}`,
                displayValue: r.name,
                wantedBeforeId: r.beforeId,
                visible: true,
              })),
              // rasterImages: rasterImages.map((r) => {

              //   return {
              //     ...r,
              //     imageUrl: r.url,
              //     coords: r.corners,
              //     id: `${r.id}`,
              //     displayValue: r.name,
              //     wantedBeforeId: r.beforeId,
              //     visible: true,
              //   };
              // }),
              piKey: piKey,
              campusKeys: props.selectedCampuses,
              language: props.language,
              version: "5",
              piData: props.piData,
              loadUnpublishedGeoJSONData: false,
              loadUnpublishedStyleMappings: false,
              loadUnpublishedGidData: false,
              mapJsonUrl: "piData",
              devMode: {
                CU_DATA_URL: `${process.env.REACT_APP_MAP_SDK_URI_CU_DATA_URL}`,
                CU_DATA_URL_PUBLIC: `${process.env.REACT_APP_MAP_SDK_URI_CU_DATA_URL_PUBLIC}`,
                CU_STYLE_PATH: `${process.env.REACT_APP_MAP_SDK_URI_CU_STYLE_PATH}`,
                CU_CAMPUS_URL: `${process.env.REACT_APP_MAP_SDK_URI_CU_CAMPUS_URL}`,
                CU_APOLLO_URL: `${process.env.REACT_APP_CU_APOLLO_URL}`,
              },
            }}
            sourceRender={() => {}}
          />
        </a.div>
      </div>
    );
  } else return null;
}
/** redux */
const mapStateToProps = (state) => {
  return {
    currentFloorIndex: state.floors.currentFloorIndex,
    useFloorBounce: state.floors.useFloorBounce,
    currentFeature: state.main.currentFeature,
    currentChildrenPOIs: state.main.currentChildrenPOIs,
    currentChildrenFeatures: state.main.currentChildrenFeatures,
    currentMapPage: state.map.currentPage,
    introComplete: state.main.introComplete,
    selectedCampuses: state.main.campusKeys,
    nodes: state.main.nodes,
    isApp: state.main.isApp,
    language: state.main.language,
    serverDataLoaded: state.main.serverDataLoaded,
    designDataLoaded: state.main.designDataLoaded,
    userAllowedGPS: state.settings.location.userAllowed,
    // mapbox infos
    geoJSONsLoaded: state.map.geoJSONsLoaded,
    geoJSONsUpdate: state.map.geoJSONsUpdate,
    currentBoundBuildingId: state.map.currentBoundBuildingId,
    mapLoaded: state.map.mapLoaded,
    lastCampusId: state.settings.campus.lastCampusId,
    mapPadding: state.map.mapPadding,
    // accessToken: state.map.accessToken,
    // location
    hasLatestPosition: state.route.hasLatestPosition,
    locationObject: state.route.locationObject,
    // html building markers
    currentMainPage: state.main.currentPage,
    showBuildingMarkers: state.map.showBuildingMarkers,
    allowBuildingMarkers: state.map.allowBuildingMarkers,
    forceFeatureFilterUpdate: state.map.forceFeatureFilterUpdate,
    // Options
    cameraMoveToHeading: state.map.cameraMoveToHeading,
    mapStyle: state.map.mapStyle,
    show3DBuildings: state.map.show3DBuildings,
    target: state.route.target,
    currentRoute: state.route.currentRoute,
    currentCampusId: state.main.currentCampusId,
    mapBounds: state.map.bounds,
    isTerminal: state.main.isTerminal,
    terminalIsIdle: state.main.terminalIsIdle,
    defaultStartNode: state.route.defaultStartNode,
    mapAngleFrozen: state.settings.mapAngle.isFrozen,
    start: state.route.start,
    mapAngleValue: state.settings.mapAngle.angle,
    terminalBearing: state.map.terminalBearing,
    urlParametersReady: state.main.urlParametersReady,
    // Ich habe keine Ahnung was ich hier tue, ich bin doch nur ein Hund.
    piData: state.main.piData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setPreOpen: () => dispatch(actionInfo.setPreOpen()),
    setMapboxServerdata: (object) =>
      dispatch(actionMap.setMapboxServerdata(object)),
    setCurrentCampusId: (id) => dispatch(actionMain.setCurrentCampusId(id)),
    setCurrentCampusKey: (campusKey) =>
      dispatch(actionMain.setCurrentCampusKey(campusKey)),

    setDebuggingValues: (object) =>
      dispatch(actionDebug.setDebuggingValues(object)),
    toggleMarkers: (showBuildingMarkers) =>
      dispatch(actionMap.toggleMarkers(showBuildingMarkers)),
    addToast: (item) => dispatch(actionToast.addToast(item)),
    setCurrentFeature: (knoten) =>
      dispatch(actionMain.setCurrentFeature(knoten)),
    setCurrentFloorNumber: (value, bounce) =>
      dispatch(actionFloor.setCurrentFloorNumber(value, bounce)),
    setMapPadding: (object, tellMap) =>
      dispatch(setMapPadding(object, tellMap)),
    setCurrentFloorIndex: (value, bounce) =>
      dispatch(actionFloor.setCurrentFloorIndex(value, bounce)),
    setMainMenuClose: () => dispatch(actionMainNav.setClose()),
    toggleIsFullMap: () => dispatch(actionMain.toggleIsFullMap()),
    setBounds: (bounds) => dispatch(actionMap.setBounds(bounds)),
    setMapLoaded: (value) => dispatch(actionMap.setMapLoaded(value)),
    incrementMapClicks: () => dispatch(actionMap.incrementMapClicks()),
    setMap: (map) => dispatch(actionMap.setMap(map)),
    setChildrenFeatures: (features) =>
      dispatch(actionMap.setChildrenFeatures(features)),
    setViewIsIndoors: (value) => dispatch(actionMap.setViewIsIndoors(value)),
    setCustomerInformation: (customer) =>
      dispatch(actionMain.setCustomerInformation(customer)),
    setGPSData: (lngLatAccuracy) => dispatch(setGPSData(lngLatAccuracy)),
    setLocationObjectZIndex: (zIndex) =>
      dispatch(setLocationObjectZIndex(zIndex)),
    setProperties: (object) => dispatch(setProperties(object)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Map));

// function useGetRasterIamges(rasterImagesProps) {
//   const [rasterImages, setRasterImages] = useState([]);

//   useEffect(() => {
//     if (rasterImages.length) return;

//     console.log("TESTTTT");
//     setRasterImages(rasterImagesProps);
//   }, [rasterImagesProps]);

//   return rasterImages;
// }
